import Menu from "../menu/PublicMenu.jsx";

const AdminLayout = ({ children }) => {
  return (
    <>
      <Menu />
      <div className="content">{children}</div>
    </>
  );
};

export default AdminLayout;
